import { clearClientSession, showSessionExpiredAlert } from "./apiAlert";

/** Redux login payload + localStorage session (token + status). */
export function readLoginState(reduxUserInformation) {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("sessionToken") : null;

  let statusOk = false;
  try {
    const storedStatus = localStorage.getItem("status");
    statusOk = storedStatus != null && JSON.parse(storedStatus) === 200;
  } catch {
    /* ignore */
  }

  const fromRedux = reduxUserInformation?.code === 200;
  const fromStorage = Boolean(token && statusOk);

  return { isLoggedIn: fromRedux || fromStorage };
}

/** Clear stale session and show the session-expired modal (login page). */
export function handleUnauthenticatedAccess() {
  clearClientSession();
  showSessionExpiredAlert();
}
